import Vue from 'vue';
import VueFacebookPixel from '@blaaat/vue-facebook-pixel';

Vue.use(VueFacebookPixel);
